import { all,fork } from "@redux-saga/core/effects";


export default function* rootSaga() {    
    // yield all([fork(watchGetRequests), fork(watchGetSingleRequest), fork(watchPostRequest), fork(watchDeleteRequest)]);
}